// Shared constants between Convex and client code

export const PARTICIPANT_PROPERTY_FIELDS = {
  todos: "todos",
  segmentAdjustments: "segmentAdjustments",
} as const;

export type ParticipantPropertyName = keyof typeof PARTICIPANT_PROPERTY_FIELDS;
